const weekdays = [
    'maandag',
    'dinsdag',
    'woensdag',
    'donderdag',
    'vrijdag',
    'zaterdag',
    'zondag',
]

const months = [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
]

const zeroPad = (num, places = 2) => String(num).padStart(places, '0')

const formatTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes - hours * 60
    return `${zeroPad(hours)}:${zeroPad(minutes)}`
}
const formatDate = (year, month, day) => `${year}-${zeroPad(month)}-${zeroPad(day)}`


const calendarRows = (days) => {
    if (!days || !days.length) return []
    const rows = []
    let currentDayOfWeek = days[0].dayOfWeek
    let currentRow = Array(currentDayOfWeek).fill(null)
    days.forEach((day, index) => {
        currentRow.push(day)
        currentDayOfWeek++
        if (currentDayOfWeek > 6) {
            rows.push(currentRow)
            currentRow = []
            currentDayOfWeek = 0
        }
    })
    if (currentRow.length) {
        while (currentRow.length < 7) currentRow.push(null)
    }
    rows.push(currentRow)
    return rows
}

export default function serviceCalendar(serviceId, apiUrl) {
    return {
        serviceId,
        apiUrl,
        days: [],
        rows: [],
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
        selectedDay: null,
        selectedSlot: null,
        getDays(month = null, year = null) {
            let url = this.apiUrl
            if (month !== null) {
                url = `${url}/${month + 1}`
                if (year) {
                    url = `${url}/${year}`
                }
            }
            fetch(url).then(response => {
                response.json().then(days => {
                    this.days = days
                    this.rows = calendarRows(days)
                })
            })
        },
        initialize() {
            this.getDays()
        },
        monthName(month) {
            return months[month]
        },
        currentMonthAndYear() {
            return `${this.monthName(this.month)} ${this.year}`
        },
        weekdayName(weekday) {
            return weekdays[weekday]
        },
        dayName(day) {
            if (!day) return
            return `${this.weekdayName(day.dayOfWeek)} ${day.day} ${this.monthName(this.month)}`
        },
        displaySlot(slot) {
            return `${formatTime(slot.from)} - ${formatTime(slot.to)}`
        },
        formatDate(day) {
            return formatDate(this.year, this.month + 1, day.day)
        },
        formatTime(slot) {
            return formatTime(slot.from)
        },
        shiftMonth(increment) {
            let newMonth = this.month + increment
            let newYear = this.year
            if (newMonth > 11) {
                newYear++
                newMonth = 0
            } else if (newMonth < 0) {
                newYear--
                newMonth = 11
            }
            this.month = newMonth
            this.year = newYear
            this.selectedDay = null
            this.selectedSlot = null
            this.getDays(newMonth, newYear)
        }
    }
}